import { registerHandler } from '@/utils/queues/pc-queues'
// TODO: Switch this to async / lazy loading because side nav isn't used on desktop
import '@/nav/sideNav'

export const registerHandlerElementSideNav = (): void => {
  registerHandler('element.sideNav', function (...args) {
    // TODO: Switch this to async / lazy loading because side nav isn't used on desktop
    // This will be used on all pages, so `webpackMode: 'eager'` is used to avoid creating an extra chunk.
    // In contrast to a static import, the module isn't executed until the call to `import()` runs.
    import(
      /* webpackMode: 'eager', webpackChunkName: '@/elements/side-nav' */ '@/elements/side-nav'
    ).then(({ init }) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore: Inlined JavaScript is inherently not type checked
      init(...args)
    })
  })
}
